import React, { useEffect, useState } from "react";
import {
  Route,
  Routes,
  Navigate,
  useNavigate,
  useLocation,
} from "react-router-dom";
import Login from "../pages/auth/Login";
import { useUser, useUser1, useUser2 } from "../redux/services/authSlice";
import DefaultLayout from "../components/layout/DefaultLayout";
import DashboardPage from "../pages/DashboardPage";
import SubjectPage from "../pages/SubjectPage";
import SubjectDetails from "../pages/SubjectPage/SubjectDetails";
import StudentPage from "../pages/Student/StudentPage";
import AddQuestion from "../pages/question/AddQuestion";
import EditQuestion from "../pages/question/EditQuestion";
import ChangePassword from "../pages/auth/ChangePassword";
import ProfilePage from "../pages/auth/ProfilePage";
import ResetPassword from "../pages/auth/ResetPassword";
import Loading from "../common/Loading";
import { setNavigateFunction } from "../redux/services/axiosApi";
import { useDispatch } from "react-redux";

const AuthenticatedRoute = ({ component: Component }) => {
  const { user1 } = useUser1();
  const { user } = useUser();
  const { user2 } = useUser2();

  const isAuthenticated =
    (user &&
      Object.keys(user).length > 0 &&
      user1 &&
      Object.keys(user1).length > 0) ||
    (user2 &&
      Object.keys(user2).length > 0 &&
      user1 &&
      Object.keys(user1).length > 0) ||
    localStorage.getItem("token");
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  return <Component />;
};

const Allroutes = () => {
  const { user1 } = useUser1();
  const { user } = useUser();
  const { user2 } = useUser2();
  const isAuthenticate =
    (user &&
      Object.keys(user).length > 0 &&
      user1 &&
      Object.keys(user1).length > 0) ||
    (user2 &&
      Object.keys(user2).length > 0 &&
      user1 &&
      Object.keys(user1).length > 0) ||
    localStorage.getItem("token");
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get("token");
    const classesId = queryParams.get("classesId");
    if (token) {
      localStorage.setItem("token", token);
      localStorage.setItem("classesId", classesId);
    }
    setTimeout(() => {
      if (window.location.search.includes("token=")) {
        window.history.replaceState(null, "", window.location.pathname);
      }
    }, 5000);
    setNavigateFunction(navigate, dispatch);
    const checkAuth = () => {
      setLoading(false);
    };

    setTimeout(checkAuth, 500);
  }, [navigate, dispatch, location]);

  if (loading) {
    return (
      <div className="h-screen">
        <Loading />
      </div>
    );
  }

  return (
    <React.Suspense fallback={""}>
      <Routes>
        <Route
          path="/login"
          element={isAuthenticate ? <Navigate to="/" replace /> : <Login />}
        />
        <Route
          path="/reset-password"
          element={
            isAuthenticate ? <Navigate to="/" replace /> : <ResetPassword />
          }
        />

        <Route
          path=""
          element={<AuthenticatedRoute component={DefaultLayout} />}
        >
          <Route
            path="/"
            element={<AuthenticatedRoute component={DashboardPage} />}
          />
          <Route
            path="/dashboard"
            element={<AuthenticatedRoute component={DashboardPage} />}
          />
          <Route
            path="/subjects"
            element={<AuthenticatedRoute component={SubjectPage} />}
          />
          <Route
            path="/subjectDetails"
            element={<AuthenticatedRoute component={SubjectDetails} />}
          />
          <Route
            path="/student"
            element={<AuthenticatedRoute component={StudentPage} />}
          />
          <Route
            path="/addQuestion"
            element={<AuthenticatedRoute component={AddQuestion} />}
          />
          <Route
            path="/editQuestion"
            element={<AuthenticatedRoute component={EditQuestion} />}
          />
          <Route
            path="/change-password"
            element={<AuthenticatedRoute component={ChangePassword} />}
          />
          <Route
            path="/profile-update"
            element={<AuthenticatedRoute component={ProfilePage} />}
          />
        </Route>
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </React.Suspense>
  );
};

export default Allroutes;
